import { HttpInterceptorFn } from '@angular/common/http';
import { AuthStore } from '../auth/auth.store';
import { inject } from '@angular/core';
import { CompanyService } from '../company/company.service';
import { getHeaderContext } from '../../share/utility/header-context';

/**
 * HTTP Interceptor to add business/company headers based on URL path
 * - If path includes 'biz': adds 'x-business-id' header
 * - If path includes 'comp': adds 'x-company-id' header
 */
const NG_APP_API_KEY = import.meta.env.NG_APP_API_KEY;

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const companyService = inject(CompanyService);

  const businessId = authStore.userSystem?.businessId;
  const companyId = companyService.getCompanyState()?.id;

  const headers: Record<string, string> = {};

  // ✅ ไม่ set content-type ถ้าเป็น FormData
  if (!(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  // ✅ set API key header
  headers['x-api-key'] = NG_APP_API_KEY;

  // ✅ ใช้ utility
  const context = getHeaderContext(req.url);

  // ✅ set header เฉพาะตอนมีค่า (สำคัญ)
  if (context === 'biz' && businessId) {
    headers['x-business-id'] = businessId;
  }

  if (context === 'comp' && companyId) {
    headers['x-company-id'] = companyId;
  }

  const clonedReq = req.clone({
    setHeaders: headers,
  });

  // ✅ log เฉพาะ dev (optional)
  // if (!environment.production) {
  //   loggingService.log('Headers:', headers);
  //   loggingService.log('URL:', req.url);
  // }

  return next(clonedReq);
};
